var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eec17d46-3393-4b50-8d12-b9ccbeeb95af",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "e8b60f10-f807-4931-b22c-ee0ff4f50905",
    cx: 8.95,
    cy: 6.18,
    r: 5.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6bb9f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#65b6f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#55aef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#3aa2ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b93eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa2db4a1-6677-4793-9372-6c604298c9d2",
    x1: 5.67,
    y1: -0.43,
    x2: 5.67,
    y2: 12.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-machinelearning-161") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.86,16.49l-.85.89a.4.4,0,0,1-.29.12H8.28A.4.4,0,0,1,8,17.38l-.85-.89a.42.42,0,0,1-.12-.3V14.1h4v2.09A.42.42,0,0,1,10.86,16.49Z",
    fill: "#a3a3a3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9,.5A5.85,5.85,0,0,0,3.13,7c.27,2.45,2.61,3.59,3.27,6.7a.48.48,0,0,0,.47.38h4.26a.48.48,0,0,0,.47-.38c.66-3.11,3-4.25,3.27-6.7A5.85,5.85,0,0,0,9,.5ZM7.06,14.1",
    fill: "url(#e8b60f10-f807-4931-b22c-ee0ff4f50905)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.33,2.58l-1,1a.14.14,0,0,1-.15,0l-1.29-.43a.16.16,0,0,0-.18.09l-.13.39a.15.15,0,0,0,.09.18L12,4.3a.16.16,0,0,1,.09.09l.45,1.35a.15.15,0,0,0,.18.09l.39-.13a.16.16,0,0,0,.09-.18l-.43-1.29a.14.14,0,0,1,0-.15l1-1a.15.15,0,0,0,0-.19,4.19,4.19,0,0,0-.26-.33A.14.14,0,0,0,13.33,2.58Z",
    fill: "#f2f2f2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7,11.79l-.06-.12a.28.28,0,0,0-.38-.12L9.43,12V7l1.15-.57a.28.28,0,0,0,.12-.38l-.06-.12a.28.28,0,0,0-.38-.13l-.83.42V.91A.42.42,0,0,1,9.65.54a5.3,5.3,0,0,0-1.3,0,.42.42,0,0,1,.22.37V6.23l-.83-.42a.28.28,0,0,0-.38.13l-.06.12a.28.28,0,0,0,.12.38L8.57,7v5l-.83-.42a.28.28,0,0,0-.38.12l-.06.12a.28.28,0,0,0,.12.38l1.15.57v1a.42.42,0,0,1-.21.37H9.64a.42.42,0,0,1-.21-.37v-1l1.15-.57A.28.28,0,0,0,10.7,11.79Z",
    fill: "#f2f2f2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79,3.24,5.71,3.6a.31.31,0,0,1-.29-.07L4.69,2.8a.28.28,0,0,0-.42,0l-.08.1a.29.29,0,0,0,0,.37L4.93,4A.29.29,0,0,1,5,4.31L4.64,5.38a.28.28,0,0,0,.18.36l.12,0a.29.29,0,0,0,.36-.17l.38-1.15a.29.29,0,0,1,.18-.18L7,3.9a.28.28,0,0,0,.18-.36l0-.12A.28.28,0,0,0,6.79,3.24Z",
    fill: "url(#aa2db4a1-6677-4793-9372-6c604298c9d2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.57,8.64l-.14-1.55-.69.07.14,1.62L10.67,9.87l.47.52L12.35,9.3l1.27.49c.14-.2.27-.4.4-.6Z",
    fill: "#f2f2f2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12,9.68l-.9-.8a.27.27,0,0,1-.09-.24l.1-1.2A.28.28,0,0,0,6,7.13H5.85a.28.28,0,0,0-.31.26l-.1,1.08a.27.27,0,0,1-.18.24l-1,.37a.27.27,0,0,0-.13.42l.07.11a.3.3,0,0,0,.34.11l.9-.35a.26.26,0,0,1,.29.06l.87.78a.27.27,0,0,0,.4,0l.09-.1A.28.28,0,0,0,7.12,9.68Z",
    fill: "#f2f2f2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11,15.31l-4,.82v.06a.42.42,0,0,0,.12.3l0,0L11,15.74Z",
    fill: "#e6e6e6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "7.01 15.57 10.98 14.75 10.98 14.32 7.01 15.14 7.01 15.57",
    fill: "#e6e6e6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/AI.9c5e3df5db7e050f8f4b4905797fc4ae.svg";
export { ForwardRef as ReactComponent };